<template>
  <header
    :class="{ 'bd-banner-navbar': isBannerEnabled}"
    class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar"
  >
    <router-link
      class="navbar-brand mr-0 mr-md-2"
      to="/"
      aria-label="asTech"
    >
      <img
        src="~@/assets/images/logo.png"
        alt="asTech"
        style="height: 36px"
      />
    </router-link>

    <div class="navbar-nav-scroll">
      <ul class="navbar-nav bd-navbar-nav flex-row">
        <li
          class="nav-item"
          v-for="n of nav"
          :key="n.name"
        >
          <router-link
            exact
            class="nav-link"
            v-if="isAllowed(n.url)"
            :to="n.url"
            title="n.name"
          >{{n.name}}</router-link>
        </li>
      </ul>
    </div>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li
        v-if="user.prn"
        class="nav-item"
      >
        <span class="nav-link">
          <i class="fas fa-user pr-1"></i>
          {{ user.prn }}
        </span>
      </li>
      <li class="nav-item">
        <a
          id="logout"
          href="#"
          @click="logout"
          class="nav-link"
          title="logout"
        >
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </li>
    </ul>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-top',
  data() {
    return {
      nav: [{ url: '/dashboard', name: 'Dashboard/Billboard' }]
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAllowed']),
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    logout() {
      this.clearToken()
      window.location.assign('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue